import React, { useEffect, useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { FieldError } from './AwpFormInputs';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import * as Popover from '@radix-ui/react-popover';
import * as ColorUtils from '@awp/helpers/ColorUtils';
import { convertColorStringToObject, hsvaToHex } from './ColorPicker/ColorUtils';
import ColorPicker, { PickerInputType } from './ColorPicker/ColorPicker';

const FormColorInput = ({
  label,
  instruction,
  readOnly = false,
  disabled = false,
  postChange = false,
  hasLightnessCheck = true,
  ...props
}) => {
  // eslint-disable-next-line no-unused-vars
  const [field, meta, { setValue }] = useField(props);

  //if it's a valid color or empty value on load default to white.
  let colorValue = field.value || '#fff';
  let colorObject;
  if (typeof colorValue === 'string') {
    colorObject = convertColorStringToObject(colorValue);
  }

  //const [hex, setHex] = useState(ColorUtils.convertToHex(colorValue));
  //const [hsv, setHsv] = useState(colorObject);

  const isDark = (colorValue) => {
    return ColorUtils.checkHSLLightness(ColorUtils.parseColorString(colorValue));
  };

  useEffect(() => {}, []);

  const onChange = (e) => {
    e.persist();
    setValue(e.target.value); // required delay for yup validation
    if (typeof e.target.value === 'string') {
      colorObject = convertColorStringToObject(e.target.value);
      // if (colorObject) {
      //   setHsv(colorObject);
      // }
    }
    if (postChange && postChange instanceof Function) postChange(e.target.value);
  };

  const getColorStyle = (value, isDisabled = false) => {
    let style = {
      width: '3rem',
    };

    if (!isDisabled) {
      style = { ...style, cursor: 'pointer', backgroundColor: value };
    } else {
      style = { ...style, cursor: 'auto', backgroundColor: value ?? '#ffffff' };
    }

    return style;
  };

  return (
    <Form.Group className="my-1">
      <div className="d-flex">
        <Form.Label className="flex-grow-1">
          <b>{label}</b>
        </Form.Label>
        <div style={{ display: 'flex', marginBottom: '-0.05rem' }}>
          <small style={{ alignSelf: 'flex-end' }}>{!readOnly && instruction}</small>
        </div>
      </div>
      <InputGroup className="mb-3">
        {readOnly || disabled ? (
          <>
            <InputGroup.Text style={{ flex: '1 0 0' }} {...field} {...props} autoComplete="off">
              {field.value}
            </InputGroup.Text>
            <InputGroup.Append>
              <Button id={`${props.id}_sample`} style={getColorStyle(hsvaToHex(colorObject), disabled)}>
                &nbsp;
              </Button>
            </InputGroup.Append>
          </>
        ) : (
          <>
            <Form.Control className="text-input" {...field} {...props} autoComplete="off" onChange={onChange} />
            <InputGroup.Append>
              <Popover.Root modal>
                <Popover.Trigger asChild>
                  <Button id={`${props.id}_sample`} style={getColorStyle(hsvaToHex(colorObject), disabled)}>
                    &nbsp;
                  </Button>
                </Popover.Trigger>
                <Popover.Portal>
                  <Popover.Content className="PopoverContent" sideOffset={5} style={{ zIndex: '10000' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                      <ColorPicker
                        color={colorObject}
                        style={{ float: 'left' }}
                        inputType={PickerInputType.HSL}
                        onChange={(color, pickerType) => {
                          let colorValue = color.hex;

                          if (pickerType === PickerInputType.RGB) {
                            colorValue = color.rgbString;
                            //colorValue = hsvaToRgbString(hexToHsva(color.hex));
                          }
                          if (pickerType === PickerInputType.HSL) {
                            colorValue = color.hslString;
                            //colorValue = hsvaToHslString(hexToHsva(color.hex));
                          }
                          setValue(colorValue);
                          //setHsv(colorObject);

                          if (postChange && postChange instanceof Function) postChange(colorValue);
                        }}
                      />
                    </div>
                    <Popover.Arrow className="PopoverArrow" />
                  </Popover.Content>
                </Popover.Portal>
              </Popover.Root>
            </InputGroup.Append>
          </>
        )}
      </InputGroup>
      {!isDark(colorValue) && colorValue != '#fff' && hasLightnessCheck ? (
        <div className="text-warning mt-1">
          <ul>
            <li>{'Color may not be dark enough'}</li>
          </ul>
        </div>
      ) : null}
      <FieldError meta={meta} />
    </Form.Group>
  );
};

FormColorInput.propTypes = {
  label: PropTypes.string,
  instruction: PropTypes.string,
  readOnly: PropTypes.bool.isRequired,
  postChange: PropTypes.func,
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default FormColorInput;
